import styled from "styled-components"


export const EmbedContentWrapper = styled.div<{hasError?: boolean}>`
  width: 100%;
  margin: 0 auto;
  max-width: ${(props) => (props.hasError && 'fit-content')};
`